export default "__VITE_ASSET__BQGsRYCQ__"